import { useQuery } from "@tanstack/react-query";
import { Ibge } from "../../../../services/Ibge";

export const useCidadesPorEstado = (sigla: string) => {
  return useQuery({
    queryKey: ["ibge-cidades-por-estado", sigla],
    queryFn: () => Ibge.CidadesPorEstado({ sigla }),
    enabled: !!sigla,
    select: (response) => response.data,
  });
};
